import { put, call, take, fork } from 'redux-saga/effects'
import { questionSelectionAddService } from '../../api/question'
import { questionSelectionAddSuccess } from '../../reducers/assignment/action'
import { QUESTION_SELECTION_ADD } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionSelectionAddFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(questionSelectionAddService, entity)

    yield put(questionSelectionAddSuccess(response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionSelectionAddWatcher() {
  while (true) {
    const action = yield take(QUESTION_SELECTION_ADD)
    const { payload } = action

    yield fork(generalSaga, questionSelectionAddFlow, payload, true)
  }
}
